import React, { FC, ReactNode, useMemo, useState } from 'react'
import { useCopyToClipboard } from 'containers/VerticalPage/common/hooks'
import { CopyOutlined } from '@ant-design/icons'
import Tooltip from 'UI/Tooltip/Tooltip'
import { shortenText } from './utils'
import styles from './CopyToClipboard.module.scss'

interface ICopyToClipboard {
  text: string
  url?: string
  children?: ReactNode | ReactNode[]
}

const CopyToClipboard: FC<ICopyToClipboard> = ({ text, url, children }) => {
  const { handleCopy, isLinkCopied } = useCopyToClipboard()

  const [showCopyBtn, setShowCopyBtn] = useState(false)

  const newText = useMemo(() => shortenText(text), [text])

  return (
    <div
      className={styles.container}
      onMouseEnter={() => setShowCopyBtn(true)}
      onMouseLeave={() => setShowCopyBtn(false)}
    >
      {url ? (
        <a href={url} target='_blank' rel='noopener noreferrer' onClick={e => e.stopPropagation()}>
          {newText}
        </a>
      ) : (
        <span>{newText}</span>
      )}
      {children && <span className={styles.children}>{children}</span>}
      <button onClick={() => handleCopy(text)} className={styles.button}>
        <Tooltip
          title={isLinkCopied ? 'Copied!' : 'Copy'}
          placement='top'
          color='#383838'
          classNames={{ root: styles.tooltipRoot, body: styles.tooltipBody }}
          mainTextContentClassName={styles.tooltipMainTextContent}
        >
          <CopyOutlined
            style={{
              color: isLinkCopied ? '#1890FF' : 'rgba(0, 0, 0, 0.85)',
              visibility: showCopyBtn ? 'visible' : 'hidden',
            }}
          />
        </Tooltip>
      </button>
    </div>
  )
}

export default CopyToClipboard
